let config = {};

if (process.env.BUILD_ENV === "prod") {
  config = require("./prod").default;
}
if (process.env.BUILD_ENV === "dev") {
  config = require("./dev").default;
}
if (process.env.BUILD_ENV === "slot") {
  config = require("./slot").default;
}

// Local 개발시 플래그 활성화 
config.isLocalDevelopment = false;
export default config;
